$(document).on('turbolinks:load', function() {
  // before measure risk survey form
  var beforeMeasureRiskSurveyFormClassName = '.new_before_measure_risk_survey';
  var $beforeMeasureRiskSurveyForm = $(beforeMeasureRiskSurveyFormClassName);
  if ($beforeMeasureRiskSurveyForm) {
    var enableBeforeMeasureRiskSurveyForm = {};
    $beforeMeasureRiskSurveyForm.each(function(index) {
      enableBeforeMeasureRiskSurveyForm[index] = true;
    })
    var beforeMeasureRiskSurveySuccessClassName = '.result__content__measures__section__risk-survey__success';
    var beforeMeasureRiskSurveyErrorClassName = '.result__content__measures__section__risk-survey__error';
    var beforeMeasureRiskSurveySubmitButtonClassName = '.result__content__measures__section__risk-survey__submit';
    var beforeMeasureRiskSurveySubmitButtonSuccessClassName = '.result__content__measures__section__risk-survey__submit--success';

    $beforeMeasureRiskSurveyForm.on('ajax:success', function(e) {
      $(this).find(beforeMeasureRiskSurveyErrorClassName).html('');
      $(this).find(beforeMeasureRiskSurveySuccessClassName).html(e.detail[0].messages.join('<br>'));

      enableBeforeMeasureRiskSurveyForm[$(this).index(beforeMeasureRiskSurveyFormClassName)] = false;
      $(this).find(beforeMeasureRiskSurveySubmitButtonClassName).toggle();
      $(this).find(beforeMeasureRiskSurveySubmitButtonSuccessClassName).toggle();
    });

    $beforeMeasureRiskSurveyForm.on('ajax:error', function(e) {
      $(this).find(beforeMeasureRiskSurveySuccessClassName).html('');
      $(this).find(beforeMeasureRiskSurveyErrorClassName).html(e.detail[0].messages.join('<br>'));
    });

    $beforeMeasureRiskSurveyForm.on('change', function() {
      if (!enableBeforeMeasureRiskSurveyForm[$(this).index(beforeMeasureRiskSurveyFormClassName)]) {
        $(this).find(beforeMeasureRiskSurveySubmitButtonClassName).toggle();
        $(this).find(beforeMeasureRiskSurveySubmitButtonSuccessClassName).toggle();
        $(this).find(beforeMeasureRiskSurveySuccessClassName).html('');
        enableBeforeMeasureRiskSurveyForm[$(this).index(beforeMeasureRiskSurveyFormClassName)] = true;
      }
    });
  }

  // after measure risk survey form
  var afterMeasureRiskSurveyFormClassName = '.new_after_measure_risk_survey';
  var $afterMeasureRiskSurveyForm = $(afterMeasureRiskSurveyFormClassName);
  if ($afterMeasureRiskSurveyForm) {
    var enableAfterMeasureRiskSurveyForm = {};
    $afterMeasureRiskSurveyForm.each(function(index) {
      enableAfterMeasureRiskSurveyForm[index] = true;
    })
    var afterMeasureRiskSurveySuccessClassName = '.result__content__measures__section__risk-survey__success';
    var afterMeasureRiskSurveyErrorClassName = '.result__content__measures__section__risk-survey__error';
    var afterMeasureRiskSurveySubmitButtonClassName = '.result__content__measures__section__risk-survey__submit';
    var afterMeasureRiskSurveySubmitButtonSuccessClassName = '.result__content__measures__section__risk-survey__submit--success';

    $afterMeasureRiskSurveyForm.on('ajax:success', function(e) {
      $(this).find(afterMeasureRiskSurveyErrorClassName).html('');
      $(this).find(afterMeasureRiskSurveySuccessClassName).html(e.detail[0].messages.join('<br>'));

      enableAfterMeasureRiskSurveyForm[$(this).index(afterMeasureRiskSurveyFormClassName)] = false;
      $(this).find(afterMeasureRiskSurveySubmitButtonClassName).toggle();
      $(this).find(afterMeasureRiskSurveySubmitButtonSuccessClassName).toggle();
    });

    $afterMeasureRiskSurveyForm.on('ajax:error', function(e) {
      $(this).find(afterMeasureRiskSurveySuccessClassName).html('');
      $(this).find(afterMeasureRiskSurveyErrorClassName).html(e.detail[0].messages.join('<br>'));
    });

    $afterMeasureRiskSurveyForm.on('change', function() {
      if (!enableAfterMeasureRiskSurveyForm[$(this).index(afterMeasureRiskSurveyFormClassName)]) {
        $(this).find(afterMeasureRiskSurveySubmitButtonClassName).toggle();
        $(this).find(afterMeasureRiskSurveySubmitButtonSuccessClassName).toggle();
        $(this).find(afterMeasureRiskSurveySuccessClassName).html('');
        enableAfterMeasureRiskSurveyForm[$(this).index(afterMeasureRiskSurveyFormClassName)] = true;
      }
    });
  }


  // support form
  var $supportForm = $('#new_support_request');
  if ($supportForm) {
    var enableSupportForm = true;
    var $supportSuccess = $('.result__content__support__success');
    var $supportError = $('.result__content__support__error');
    var $supportSubmitButton = $('.result__content__support__submit');
    var $supportSubmitButtonSuccess = $('.result__content__support__submit--success');
    $supportForm.on('ajax:success', function(e) {
      $supportError.html('');
      $supportSuccess.html(e.detail[0].messages.join('<br>'));

      enableSupportForm = false;
      $supportSubmitButton.toggle();
      $supportSubmitButtonSuccess.toggle();
    });

    $supportForm.on('ajax:error', function(e) {
      $supportSuccess.html('');
      $supportError.html(e.detail[0].messages.join('<br>'));
    });

    $supportForm.on('change', function() {
      if (!enableSupportForm) {
        $supportSubmitButton.toggle();
        $supportSubmitButtonSuccess.toggle();
        $supportSuccess.html('');
        enableSupportForm = true;
      }
    });
  }

  // service survey form
  var $serviceSurveyForm = $('#new_service_survey');
  if ($serviceSurveyForm) {
    var enableServiceSurveyForm = true;
    var $serviceSurveySuccess = $('.result__content__service-survey__success');
    var $serviceSurveyError = $('.result__content__service-survey__error');
    var $serviceSurveySubmitButton = $('.result__content__service-survey__submit');
    var $serviceSurveySubmitButtonSuccess = $('.result__content__service-survey__submit--success');

    $serviceSurveyForm.on('ajax:success', function(e) {
      $serviceSurveyError.html('');
      $serviceSurveySuccess.html(e.detail[0].messages.join('<br>'));

      enableServiceSurveyForm = false;
      $serviceSurveySubmitButton.toggle();
      $serviceSurveySubmitButtonSuccess.toggle();
    });

    $serviceSurveyForm.on('ajax:error', function(e) {
      $serviceSurveySuccess.html('');
      $serviceSurveyError.html(e.detail[0].messages.join('<br>'));
    });

    $serviceSurveyForm.on('change', function() {
      if (!enableServiceSurveyForm) {
        $serviceSurveySubmitButton.toggle();
        $serviceSurveySubmitButtonSuccess.toggle();
        $serviceSurveySuccess.html('');
        enableServiceSurveyForm = true;
      }
    });
  }
});
